// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { trackingNumberDetailsSchema } from '@/constants/shipping-carrier';
import { dateTimeSchema } from '@/utilities/date-time-schema';
import { z } from 'zod';

/**
 * Schema for a tracking event location.
 */
const trackingLocationSchema = z.object({
  zip: z.string(),
  city: z.string(),
  state: z.string(),
  country: z.string(),
});

/**
 * Schema for a tracking history item.
 * Represents a single status update from a carrier.
 */
const trackingItemSchema = z.object({
  id: z.string(),
  key: z.string(),
  createdAt: dateTimeSchema,
  reportedAt: dateTimeSchema,
  updatedAt: dateTimeSchema,
  status: z.string(),
  substatus: z.string().nullable(),
  statusText: z.string(),
  location: trackingLocationSchema.nullable(),
});

export type TrackingItem = z.infer<typeof trackingItemSchema>;

/**
 * Schema for the tracking response.
 * Contains carrier information and the list of tracking events.
 */
export const trackingDataSchema = z.object({
  // The tracked carrier can be one the app does not list, such as Shippo's test carrier.
  trackingNumberDetails: trackingNumberDetailsSchema
    .extend({ carrier: z.string().nullable() })
    .nullable(),
  eta: dateTimeSchema.nullable(),
  originalEta: dateTimeSchema.nullable(),
  serviceLevelName: z.string().nullable(),
  shippingHistory: z.array(trackingItemSchema),
});

export type TrackingData = z.infer<typeof trackingDataSchema>;
